import { faArrowLeft, faBuildingCircleCheck, faCircleUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getSession } from "../utils/utils";

function OpcionesMantenimiento() {
    const navigate = useNavigate();

    const [userInfo, setUserInfo] = useState({
        email: null,
        name: null,
        company: null,
        role: null
    });

    async function getInfo() {
        let session = await getSession();
        
        if (session !== null) {
            setUserInfo(session);
            return;
        }

        navigate("/");

        return;
    }

    useEffect(
        function () {
            getInfo();
        }
        , []
    )

    return (
        // 
        <div className="p-10 w-auto items-center h-full">
            {/* <div className="flex justify-center items-center ml-24 w-auto mr-4 h-full"> */}
            <div className="flex flex-col w-full h-full">
                <div className="flex flex-row justify-start items-center mt-4">
                    <Link to="/Inicio" className="flex justify-start">
                        <button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white w-full rounded-full w-[50px] h-[50px] p-[12px] mr-3"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
                    </Link>
                    <p className="text-4xl font-bold text-[#063E5F] text-center">Mantenimiento</p>
                </div>
                <div className="flex flex-wrap h-full items-center justify-center">
                    {(userInfo.role === "Admin") && (
                        <div className="w-full lg:w-1/3 px-1">
                            <div className="px-6 py-5 bg-[#0E7FA0] rounded-xl">
                                <div className="text-center py-2">
                                    <div className="rounded-full bg-white p-6 inline-block ">
                                        <FontAwesomeIcon icon={faBuildingCircleCheck} className="text-[#0E7FA0] text-6xl" />
                                    </div>
                                </div>
                                <div className="px-5 py-4 text-white w-auto text-center">
                                    <h1 className="font-bold text-xl">CAPIS certificados</h1>
                                    <p className="text-sm">Visualizar los datos de los CAPIS</p>
                                </div>
                                <div className="flex justify-center">
                                    <Link to="/NuevoCapi" className="rounded-full text-center bg-white p-[10px] text-[#0E7FA0] font-bold text-sm w-[120px] mx-2 transition-colors hover:bg-[#d9a51c] hover:text-white">
                                        Añadir
                                    </Link>
                                    <Link to="/VistaDatosCapis" className="rounded-full text-center bg-[#FBC022] p-[10px] text-[#0E7FA0] font-bold text-sm w-[120px] mx-2 transition-colors hover:bg-[#d9a51c] hover:text-white">
                                        Visualizar
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="w-full lg:w-1/3 px-1">
                        <div className="px-6 py-5 bg-[#0E7FA0] rounded-xl">
                            <div className="text-center py-2">
                                <div className="rounded-full bg-white p-6 inline-block ">
                                    <FontAwesomeIcon icon={faCircleUser} className="text-[#0E7FA0] text-6xl" />
                                </div>
                            </div>
                            <div className="px-5 py-4 text-white w-auto text-center">
                                <h1 className="font-bold text-xl">
                                    {(userInfo.role === "Admin") ? "Empresa" : "Sucursal"}
                                </h1>
                                <p className="text-sm">
                                    {(userInfo.role === "Admin") ? "Visualizar los datos de las empresas" : "Visualizar los datos de las sucursales"}
                                </p>
                            </div>
                            {(userInfo.role === "Admin") ?
                                <div className="flex justify-center">
                                    <Link to="/NuevaEmpresa" className="rounded-full text-center bg-white p-[10px] text-[#0E7FA0] font-bold text-sm w-[120px] mx-2 transition-colors hover:bg-[#d9a51c] hover:text-white">
                                        Añadir
                                    </Link>
                                    <Link to="/VistaDatosEmpresas" className="rounded-full text-center bg-[#FBC022] p-[10px] text-[#0E7FA0] font-bold text-sm w-[120px] mx-2 transition-colors hover:bg-[#d9a51c] hover:text-white">
                                        Visualizar
                                    </Link>
                                </div> :
                                <div className="flex justify-center">
                                    <Link to="/NuevaSucursal" className="rounded-full text-center bg-white p-[10px] text-[#0E7FA0] font-bold text-sm w-[120px] mx-2 transition-colors hover:bg-[#d9a51c] hover:text-white">
                                        Añadir
                                    </Link>
                                    <Link to="/VistaDatosSucursales" className="rounded-full text-center bg-[#FBC022] p-[10px] text-[#0E7FA0] font-bold text-sm w-[120px] mx-2 transition-colors hover:bg-[#d9a51c] hover:text-white">
                                        Visualizar
                                    </Link>
                                </div>
                            }
                        </div>
                    </div>
                    {(userInfo.role === "Empresa") && (
                        <div className="w-full md:w-1/3 px-1">
                            <div className="px-6 py-5 bg-[#0E7FA0] rounded-xl">
                                <div className="text-center py-2">
                                    <div className="rounded-full bg-white p-6 inline-block ">
                                        <FontAwesomeIcon icon={faUsers} className="text-[#0E7FA0] text-6xl" />
                                    </div>
                                </div>
                                <div className="px-5 py-4 text-white w-auto text-center">
                                    <h1 className="font-bold text-xl">Colaboradores</h1>
                                    <p className="text-sm">Visualizar los datos de los colaboradores</p>
                                </div>
                                <div className="flex justify-center">
                                    {/* <Link to="/NuevoCapi" className="rounded-full text-center bg-white p-[10px] text-[#0E7FA0] font-bold text-sm w-[120px] mx-2 transition-colors hover:bg-[#d9a51c] hover:text-white">
                                        Añadir
                                    </Link> */}
                                    <Link to="/VistaDatosColaboradores" className="rounded-full text-center bg-[#FBC022] p-[10px] text-[#0E7FA0] font-bold text-sm w-[120px] mx-2 transition-colors hover:bg-[#d9a51c] hover:text-white">
                                        Visualizar
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default OpcionesMantenimiento;